
export const enum valorTipoSistemaEnum {
    DESENVOLVIMENTO = 1,
    PRODUCAO = 2,
    HOMOLOGACAO = 3
}

export class TipoSistemaEnum {
    public static values = [
        { label: 'Selecione uma opção', value: null },
        { label: 'Desenvolvimento', value: valorTipoSistemaEnum.DESENVOLVIMENTO },
        { label: 'Produção', value: valorTipoSistemaEnum.PRODUCAO },
        { label: 'Homologação', value: valorTipoSistemaEnum.HOMOLOGACAO }
    ]

    public static getDescricao(id: number) {
        let descricao = '';

        for (const key in TipoSistemaEnum.values) {
            if (id === TipoSistemaEnum.values[key].value) {
                descricao = TipoSistemaEnum.values[key].label;
                break;
            }
        }

        return descricao;
    };

    public static getId(descricao: string) {

        let id;

        for (const key in TipoSistemaEnum.values) {
            if (descricao.toLowerCase() === TipoSistemaEnum.values[key].label.toLowerCase()) {
                id = TipoSistemaEnum.values[key].value;
                break;
            }
        }

        return id;
    };



}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/dominios/enum/tipo-sistema.enum.ts